// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"99945dec7e386be127ea","678":"68c99be0e9c086e687e7","883":"82ba9480297233d14e7e"}[chunkId] + ".js";
};